// extracted by mini-css-extract-plugin
export var check = "styles-module--check--dda7a";
export var columnReverse = "styles-module--columnReverse--e9c5e";
export var courseName = "styles-module--courseName--5c7eb";
export var hero = "styles-module--hero--8f15e";
export var heroImage = "styles-module--heroImage--9b984";
export var imageWrapper = "styles-module--imageWrapper--4c398";
export var listItem = "styles-module--listItem--03fb2";
export var padding = "styles-module--padding--b48ac";
export var rtlListIcon = "styles-module--rtlListIcon--7bb34";
export var rtlStrapiHeroCourse = "styles-module--rtlStrapiHeroCourse--691d6";
export var rtlStrapiHeroDescription = "styles-module--rtlStrapiHeroDescription--711ed";
export var rtlStrapiHeroImage = "styles-module--rtlStrapiHeroImage--b7084";
export var rtlStrapiHeroList = "styles-module--rtlStrapiHeroList--64faa";
export var rtlStrapiHeroShortDescription = "styles-module--rtlStrapiHeroShortDescription--f0f46";
export var rtlcourseName = "styles-module--rtlcourseName--ec909";